import axiosInstance from "../axiosInstance";
import API_ROUTES from "../apiRoutes";

export const AdminApi = {
  getAdmins: () => axiosInstance.get(API_ROUTES.ADMIN.LIST),
  createAdmin: (data) => axiosInstance.post(API_ROUTES.ADMIN.CREATE, data),
  passwordReset: (data) =>
    axiosInstance.post(API_ROUTES.ADMIN.PASSWORD_RESET, data),
  removeAdmin: (data) => axiosInstance.post(API_ROUTES.ADMIN.REMOVE, data),
};
